<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>With thanks to the Five, who encouraged me to believe I could write, and to my mum and grandparents, who encouraged me to believe I could do anything.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?2f56f311